<template>
  <div>
      <span v-for="(coAuthor, key) in authors" v-if="authors" :key="key"
            style=" text-align: left; position: relative; ">
        <label class="text-info dropdown-toggle " :id="'biblioDropdownMenu-'+coAuthor.authorID"
               data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="true" :class="{active: coAuthor.selected}"
               style="cursor: pointer;">
                {{coAuthor.lastName}} {{coAuthor.firstName}}
         </label>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                <li><a role="button" @click="dropDownClick('addAuthor',coAuthor , $event)"><i
                class="fa fa-user-plus text-success"></i> Add expert</a></li>
                <li class="expert-list-action-li-search"><a role="button"
                                                            @click="dropDownClick('search', coAuthor, $event)"><i
                class="fa fa-search text-info"></i> Search expert</a></li>
              </ul>
         <template v-if="key < authors.length-1">, </template>
        </span>
  </div>
</template>

<style scoped>
.dropdown-suggestion > ul > li i{
  color: #ffc107;
  font-weight: bold;
}

.dropdown-suggestion > ul > li a{
  font-size: 12px;
}

.dropdown-suggestion > ul > li{
  margin-bottom: 5px;
  font-size: 12px;
}

</style>
<script>

import EditAuthor from '../modal/EditAuthor'
export default {
  components: {EditAuthor},
  props: ['value', 'listId', 'companyAuthors', 'query', 'docId', 'isReadOnly'],
  name: 'BiblioDocumentAuthors',
  data () {
    return {
      authors: null
    }
  },
  watch: {
    value: function (value) {
      this.authors = JSON.parse(value)
    }
  },
  methods: {
    dropDownClick: function (action, author, event) {
      switch (action) {
        case 'addAuthor':
          this.addItem(author, 'author')
          break
        case 'search':
          let query = 'name:"' + author.firstName.replace(/\s/g, ' ').replace(/\./g, ' ').trim() + ' ' + author.lastName.trim() + '"'
          this.$router.replace({name: 'Search', params: {'query': query}})
          setTimeout(() => {
            $('.modal-backdrop').hide()
          }, 500)
          break
      }

      $('#biblioDropdownMenu-' + author.authorID).dropdown('toggle')

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    },
    addItem: function (author, type) {
      console.log('add expert')
      if (this.isInSelected(author)) {
        this.$notify({
          type: 'info',
          title: '',
          content: 'Authors already in selected experts List',
          placement: 'bottom-right'
        })
      } else if (this.isInSimilar(author)) {
        this.$requestStack.add('patch', '/list/' + this.listId + '/author/' + author.authorID,
          {is_suggested: false}, 0)
          .then((response) => {
            this.$eventHub.$emit('updateCompanyAuthorList', true)

            this.$notify({
              type: 'success',
              title: 'Well done!',
              content: 'Author moved to selected experts List',
              placement: 'bottom-right'
            })

            this.$salesMachine.addItem({author: author, type: type})
          })
          .catch((error) => {
          })
      } else {
        this.$requestStack.add('post', '/list/' + this.listId + '/author/',
          this.getDataForQueryAddAuthor(author, type), 0)
          .then((response) => {
            this.$eventHub.$emit('updateCompanyAuthorList', true)

            this.$notify({
              type: 'success',
              title: 'Well done!',
              content: 'Author added in your list',
              placement: 'bottom-right'
            })

            this.$salesMachine.addItem({author: author, type: type})
          })
          .catch((error) => {
            this.$notify({
              type: 'error',
              title: 'Oops, add expert failed !',
              content: "An error occurred during the add expert operation! Please try 'search expert' than added from search result.",
              placement: 'bottom-right'
            })
          })
      }
    },
    getDataForQueryAddAuthor: function (author, type) {
      let data = []
      data.push({
        author_id: author.authorID,
        documents: [this.docId],
        score: 1,
        search_terms: this.query,
        is_suggested: false,
        external_expert_suggestion_id: null,
        type: type
      })

      return data
    },
    isInSimilar: function (author) {
      let flag = false
      if (this.companyAuthors && this.companyAuthors.authors_similar && this.companyAuthors.authors_similar.length) {
        this.companyAuthors.authors_similar.forEach(
          (authorSimilar) => {
            if (authorSimilar.authorID === author.authorID) {
              flag = true
              return true
            }
          }
        )
      }
      return flag
    },
    isInSelected: function (author) {
      let flag = false
      if (this.companyAuthors && this.companyAuthors.authors_selected && this.companyAuthors.authors_selected.length) {
        this.companyAuthors.authors_selected.forEach(
          (authorSelected) => {
            if (authorSelected.authorID === author.authorID) {
              flag = true
              return true
            }
          }
        )
      }
      return flag
    }
  },
  beforeMount () {
    this.authors = JSON.parse(this.value)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/biblio/BiblioDocumentAuthors.vue